/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';

    import HalConverter = Models.HalConverter;

    export class ManagementService {
        public static $name: string = "managementService";
        public static $inject: string[] = ['$q', 'backendService'];

        private backendService: Services.BackendService;

        private backendBaseUrl: string = window.backendUrl;
        private serviceUrl: string = this.backendBaseUrl + 'mvpadapter/mgmt/';

        private $q: ng.IQService;

        constructor($q: ng.IQService,
                    backendService: Services.BackendService) {
            this.$q = $q;
            this.backendService = backendService;
        }

        public getClientInfo(serial: string): ng.IPromise<Models.IClientInfo> {
            return this.backendService.get(this.serviceUrl + 'getClientInfo/' + serial)
            .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Models.IClientInfo>>) => {
                 return HalConverter.convertElement(result.data, Models.ClientInfo.createEmpty);
            });
        }

        public getManagementInfo(serial: string): ng.IPromise<Models.IManagementInfo> {
            return this.backendService.get(this.serviceUrl + 'getManagementInfo/' + serial)
            .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Models.IManagementInfo>>) => {
                 return HalConverter.convertElement(result.data, Models.ManagementInfo.createEmpty);
            });
        }
    }
}